/**
 * Hides the vanilla html/css splashscreen defined in public/index.html
 */
export const hideSplashscreen = () => toggleSplashscreen(false)

/**
 * Shows the vanilla html/css splashscreen defined in public/index.html
 */
export const showSplashscreen = () => toggleSplashscreen(true)

/**
 * Shows the given message into the vanilla html/css splashscreen defined in public/index.html
 */
export const showSplashscreenMessage = error => {
  toggleSplashscreen(true)
  document.getElementById('spinner').innerHTML = error
}

/**
 * Hides or shows the vanilla html/css splashscreen defined in public/index.html
 * @param {Boolean} visible whether to hide or show the splashscreen
 */
const toggleSplashscreen = visible => {
  // wait for next tick to let react finish its rendering before toggling
  setTimeout(() => {
    document.getElementById('splashscreen').style.display = visible ? 'flex' : 'none'
  })
}
